import React, { useEffect, useState } from "react";
import { Stack, Typography, Chip, Box } from "@mui/material";
import { request } from "../../utils/request";
import ChartCard from "./ChartCard";
import ChartRenderer from "./ChartRenderer";
import { enterpriseChartTheme } from "./chartTheme";

const CustomChartsWidget = () => {
  const [charts, setCharts] = useState([]);
  const [data, setData] = useState([]);
  const [chartType, setChartType] = useState("bar");

  useEffect(() => {
    const load = async () => {
      try {
        const res = await request("customcharts", { method: "GET" });
        const saved = Array.isArray(res?.data) ? res.data : [];
        setCharts(saved);
        if (saved[0]) {
          setChartType(saved[0].chartType || "bar");
          const preview = await request("customcharts/preview", {
            method: "POST",
            body: { ...saved[0], filters: Array.isArray(saved[0].filters) ? saved[0].filters : [] },
          });
          setData(Array.isArray(preview?.data) ? preview.data : []);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error(error);
      }
    };
    load();
  }, []);

  return (
    <ChartCard
      title="Custom Charts"
      description="Saved analytics widgets from Database"
      meta={{ modelName: charts.length ? `${charts.length} saved` : "No charts yet", lastUpdated: "Live", subtitle: "Enterprise analytics" }}
      isActive
      onRefresh={() => window.location.reload()}
    >
      <Stack spacing={1.25} sx={{ height: "100%" }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="caption" sx={{ fontWeight: 700, color: "#475569", letterSpacing: "0.06em", textTransform: "uppercase" }}>
            Dashboard widget
          </Typography>
          <Chip label={`${charts.length} saved`} size="small" sx={{ borderRadius: 999, background: "rgba(37, 99, 235, 0.1)", color: "#2563eb" }} />
        </Stack>
        {data.length ? (
          <Box sx={{ flex: 1, minHeight: 0 }}>
            <ChartRenderer data={data} chartType={chartType} xKey="name" yKey="value" colors={[enterpriseChartTheme.colors[0]]} />
          </Box>
        ) : (
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              border: "1px dashed rgba(148, 163, 184, 0.45)",
              borderRadius: 2,
              background: "rgba(248, 250, 252, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              px: 2,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Create a chart to see it appear here.
            </Typography>
          </Box>
        )}
      </Stack>
    </ChartCard>
  );
};

export default CustomChartsWidget;
